import axios from 'axios'

export default {
  getDataset: (datasetKey) => {
    return axios.get(`/api/dataset/${datasetKey}`)
  },
  addItem: (datasetKey, endpoint, data) => {
    return axios.post(`/api/dataset/${datasetKey}/${endpoint}`, data)
  },
  removeItem: (datasetKey, endpoint, itemKey) => {
    return axios.delete(`/api/dataset/${datasetKey}/${endpoint}/${itemKey}`)
  },
  editItem: (datasetKey, endpoint, itemKey, data) => {
    return axios.patch(`/api/dataset/${datasetKey}/${endpoint}/${itemKey}`, data)
  },
  createDataset: (data) => {
    return axios.post('/api/dataset', data)
  },
  removeMedia: (datasetKey, mediaKey) => {
    return axios.delete(`/api/dataset/${datasetKey}/media/${mediaKey}`)
  },
  addMedia: (datasetKey, data) => {
    const options = { headers: { 'Content-Type': 'multipart/form-data' } }
    return axios.post(`/api/dataset/${datasetKey}/media`, data, options)
  },
  deleteDataset: (datasetKey) => {
    return axios.delete(`/api/dataset/${datasetKey}`)
  },
  saveDataset: (datasetKey, data) => {
    return axios.patch(`/api/dataset/${datasetKey}`, data)
  },
  fetchAllDatasets: () => {
    return axios.get('/api/datasets')
  },
  fetchAllDataFormats: () => {
    return axios.get('/api/dataformat')
  },
  fetchAllClassifications: () => {
    return axios.get('/api/classification')
  },
  fetchAllMediaTypes: () => {
    return axios.get('/api/mediatype')
  },
  fetchAllPIs: () => {
    return axios.get(`/api/pi`)
  },
  fetchAllResourceTypes: () => {
    return axios.get('/api/resourcetype')
  },
  /* Unsure if we need the below code, used by create but I think addItem can be used. */
  addDatasetDataFormat: (datasetKey, data) => {
    return axios.post(`/api/dataset/${datasetKey}/dataformat`, data)
  },
  addDatasetClassification: (url, data) => {
    return axios.post(url, data)
  }
}
